// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-scroll-area {
  overflow: auto;
  scrollbar-width: thin;
}
.dropdown-scroll-area__inner {
  width: fit-content;
  min-width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/components/dropdown-menu/DropdownScrollArea.less"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,qBAAA;AACF;AACE;EACE,kBAAA;EACA,eAAA;AACJ","sourcesContent":[".dropdown-scroll-area {\n  overflow: auto;\n  scrollbar-width: thin;\n\n  &__inner {\n    width: fit-content;\n    min-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
